const t = "outOfOrder_gqyi0", o = "outOfOrder__logo_x0sUF", r = "outOfOrder__subtitle_ELqL1", O = {
  outOfOrder: t,
  outOfOrder__logo: o,
  outOfOrder__subtitle: r
};
export {
  O as default,
  t as outOfOrder,
  o as outOfOrder__logo,
  r as outOfOrder__subtitle
};
//# sourceMappingURL=OutOfOrder.module.scss.js.map
